import { render, staticRenderFns } from "./BindingModal.vue?vue&type=template&id=134550b2&scoped=true&"
import script from "./BindingModal.vue?vue&type=script&lang=js&"
export * from "./BindingModal.vue?vue&type=script&lang=js&"
import style0 from "./BindingModal.vue?vue&type=style&index=0&id=134550b2&scoped=true&lang=css&"
import style1 from "./BindingModal.vue?vue&type=style&index=1&id=134550b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134550b2",
  null
  
)

export default component.exports